export default __webpack_public_path__ + "static/media/signin-persona-fair-people.314d704b.svg";